/** Request-size limits shared by the API and its clients (protocol constants, not plan limits). */
export const TRANSCRIBE_MAX_PER_REQUEST = 20;
export const TRANSCRIPTS_MAX_PER_REQUEST = 500;
/** Compare Creators shows at most this many creators side by side (SPEC §19.2; a layout bound, not a plan limit). */
export const COMPARE_MAX_CREATORS = 5;

/**
 * The fixed Cloudflare rate-limit bindings (decision 59). Their limits live in apps/api/wrangler.toml and can't be
 * read from the database at runtime, so they are not Admin settings: Admin → System shows them read-only from here.
 * A test keeps this list and wrangler.toml (both environments) in step. Business limits (scans, transcription
 * minutes, MCP access) are plan limits, edited in Admin → Plans.
 */
export interface FixedRateLimit {
  binding: 'AUTH_RATE_LIMITER' | 'EXT_RATE_LIMITER' | 'POLL_RATE_LIMITER' | 'SIGNIN_RATE_LIMITER';
  limit: number;
  periodSeconds: number;
  /** What one bucket is keyed by. */
  per: string;
  /** Which routes use it. */
  covers: string;
}

export const FIXED_RATE_LIMITS: readonly FixedRateLimit[] = [
  { binding: 'AUTH_RATE_LIMITER', limit: 20, periodSeconds: 60, per: 'IP + user-agent, IP or user',
    covers: 'Extension pairing (per IP), public pages and the removal form (per IP + user-agent), account export/delete, export downloads, MCP sign-in pages' },
  { binding: 'EXT_RATE_LIMITER', limit: 300, periodSeconds: 60, per: 'paired browser, user, or IP + user-agent',
    covers: 'Signed extension requests (sync, reels, library, collections), transcribe, compare, analytics beacon (per IP + user-agent), MCP tool calls and client registration' },
  // Decision 90 (2026-10-24): about one scan-status poll per 5 s per paired browser (the poll writes nothing).
  { binding: 'POLL_RATE_LIMITER', limit: 2, periodSeconds: 10, per: 'paired browser',
    covers: 'Scan-status polls from the extension (GET /api/ext/scans/:id), with a poll token or signed' },
  // Decision 90: sign-in keyed on IP + user-agent and raised from 20 to 60 a minute, so a carrier-NAT crowd sharing one
  // IP isn't refused; per-account limits stay on AUTH_RATE_LIMITER.
  { binding: 'SIGNIN_RATE_LIMITER', limit: 60, periodSeconds: 60, per: 'IP + user-agent',
    covers: 'Google sign-in (start and callback)' },
];
